import { CircularProgress, styled } from '@mui/material'
import { FC } from 'react'

const CenteredCtn = styled('div')({
  height: '100%',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export const CenteredSpinner: FC = () => (
  <CenteredCtn>
    <CircularProgress size={20} color="primary" />
  </CenteredCtn>
)
